import { render, staticRenderFns } from "./HistoryIndicators.vue?vue&type=template&id=d01060b4"
import script from "./HistoryIndicators.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryIndicators.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports